import { createAction } from 'redux-actions';

const saveProfileId = createAction('SAVE_PROFILE_ID');
saveProfileId.TYPE = saveProfileId.toString();

export default saveProfileId;

